import { NgModule } from '@angular/core';
import { ModalCreditRegisterErrorComponent } from './modal-credit-register-error/modal-credit-register-error.component';
import { ModalCreditRegisterInfoComponent } from './modal-credit-register-info/modal-credit-register-info.component';
import { ModalCreditRegisterSuccessComponent } from './modal-credit-register-success/modal-credit-register-success.component';

@NgModule({
  imports: [
    ModalCreditRegisterSuccessComponent,
    ModalCreditRegisterErrorComponent,
    ModalCreditRegisterInfoComponent,
  ],
  exports: [
    ModalCreditRegisterSuccessComponent,
    ModalCreditRegisterErrorComponent,
    ModalCreditRegisterInfoComponent,
  ],
})
export class CreditRegisterModalModule {}
